<template>
  <div id="compliance-others-create" class="page">
    <div class="header">
      <div class="description">
        <h1 class="title">Nova Consulta</h1>
      </div>
    </div>

    <div
      v-if="!tag"
      class="card available-documents"
      :class="{ '-loading': loading }"
    >
      <div class="header">
        <div class="description">
          <h2 class="title">Selecione o documento</h2>
        </div>
      </div>

      <div class="body">
        <validation-observer ref="form">
          <form @submit.prevent="submitForm">
            <validation-provider v-slot="{ errors }" rules="required">
              <div class="group-fields">
                <legend class="groupTitle">Selecionar Documento</legend>

                <div class="form-group" :class="{ '-has-error': errors.length > 0 }">
                  <multiselect
                    :options="formattedDocuments"
                    :multiple="false"
                    class="form-control"
                    label="label"
                    track-by="name"
                    id="consultations"
                    placeholder="Selecione uma opção"
                    select-label="Pressione enter para selecionar"
                    selected-label="Selecionado"
                    deselect-label="Pressione enter para remover"
                    v-model="tags"
                  ></multiselect>
                  <p class="description" v-if="errors.length > 0">{{ errors[0] }}</p>
                </div>
              </div>
            </validation-provider>

            <div style="display: flex;justify-content: flex-end;">
              <button type="submit" class="btn btn-primary" @click="tag = tags.name">Avançar</button>
            </div>
          </form>
        </validation-observer>
      </div>
    </div>

    <new-query
      v-if="tag"
      :tag.sync="tag"
      consultations-route="/compliance/others"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import NewQuery from '@/compliance/components/NewQuery.vue';
import unCamelCase from '@/support/filters/unCamelCase';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import Multiselect from 'vue-multiselect';

export default {
  name: 'Create',

  data() {
    return {
      tag: '',
      tags: [],
      loading: false,
    };
  },

  methods: {
    async fetchDocumentsList() {
      try {
        this.loading = true;

        await this.$store.dispatch('compliance/fetchDocumentsList');
      } finally {
        this.loading = false;
      }
    },

    async submitForm() {
      return !!(await this.$refs.form.validate());
    },
  },

  mounted() {
    this.fetchDocumentsList();
  },

  computed: {
    ...mapState('compliance', {
      documents: 'documents',
    }),
    formattedDocuments() {
      return this.documents.map((item) => ({
        name: item.name,
        label: unCamelCase(item.name),
      }));
    },
  },

  filters: {
    unCamelCase,
  },

  components: {
    NewQuery,
    ValidationProvider,
    ValidationObserver,
    Multiselect,
  },
};
</script>

<style lang="scss" scoped>
#compliance-others-create {
  > .available-documents {
    > .header {
      > .title {
        @apply text-secondary-500;
        @apply text-center;
      }

      > .subtitle {
        @apply text-secondary-400;
        @apply text-center;
      }
    }

    > .body {
      > .documents-list {
        @apply pt-6;
        @apply flex;
        @apply flex-col;

        > .row {
          @apply mb-4;
          @apply text-center;

          > .chooseDocument {
            min-width: 210px;
          }
        }
      }
    }
  }
}
</style>
